import PagePopups from "components/PagePopups";
import { langs } from "helpers/lang";
import React from "react";
import { Route, Routes } from "react-router-dom";
import RedirectRoutes from "./RedirectRoutes";
import PublicRoutes from "./Routes";

const Page: React.FC = () => {
  return (
    <PagePopups>
      <Routes>
        <Route
          path={`/${langs.en}/*`}
          element={<PublicRoutes locale={langs.en} />}
        />
        <Route
          path={`/${langs.es}/*`}
          element={<PublicRoutes locale={langs.es} />}
        />
        <Route path="/*" element={<PublicRoutes locale={langs.pt} />} />
        <Route path="*" element={<RedirectRoutes />} />
      </Routes>
    </PagePopups>
  );
};

export default Page;
